/**
 * Tekst do UI z modelu z Mobility: używa tłumaczenia dla bieżącego locale (serializowane
 * jako `{field}_translation`), a gdy jest puste — wartości głównej kolumny `{field}`.
 *
 * @example displayTranslatedField(area, 'name')
 */
export function displayTranslatedField(obj: object, field: string): string {
  const record = obj as Record<string, unknown>;

  const translationKey = `${field}_translation`;
  const translated = record[translationKey];
  const translatedTrimmed =
    typeof translated === 'string' ? translated.trim() : '';

  if (translatedTrimmed) {
    return translatedTrimmed;
  }

  const base = record[field];
  return base == null ? '' : String(base);
}
